module.exports = __webpack_public_path__ + "img/1-1.040eb421.jpg";